/* eslint-disable */
const en = {
  message: {
    location: 'Location',
    experience: 'Experience',
    education: 'Education',
    skills: 'Skills',
    languages: 'Languages',
    portfolio: 'Portfolio',
    honors: 'Honors',
    about: 'About Me',
    external: 'External',
    contact: 'Contact'
  }
}
export default en
